const tables = [
  {
    name: "Name",
  },
  {
    name: "Email",
  },
  {
    name: "Phone",
  },
  {
    name: "Opening Balance",
  },
  {
    name: "Total Debit",
  },
  {
    name: "Total Credit",
  },
  {
    name: "Current Balance",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
